// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Badge$Showside from "./Badge.bs.js";
import * as Spread$Showside from "../utils/Spread.bs.js";
import * as IconLoading$Showside from "../icons/IconLoading.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
function IconButton(Props) {
  var onClickOpt = Props.onClick;
  var onClickAsync = Props.onClickAsync;
  var onMouseDownOpt = Props.onMouseDown;
  var disabledOpt = Props.disabled;
  var shadowOpt = Props.shadow;
  var darkOpt = Props.dark;
  var outlineOpt = Props.outline;
  var clearOpt = Props.clear;
  var roundedOpt = Props.rounded;
  var scaleOpt = Props.scale;
  var relativeOpt = Props.relative;
  var size = Props.size;
  var iconSizeOpt = Props.iconSize;
  var labelSizeOpt = Props.labelSize;
  var labelStyle = Props.labelStyle;
  var icon = Props.icon;
  var iconFirstOpt = Props.iconFirst;
  var verticalOpt = Props.vertical;
  var noMarginOpt = Props.noMargin;
  var badge = Props.badge;
  var href = Props.href;
  var label = Props.label;
  var title = Props.title;
  var dataTestId = Props.dataTestId;
  var dataActive = Props.dataActive;
  var iconClassNameOpt = Props.iconClassName;
  var labelClassNameOpt = Props.labelClassName;
  var classNameOpt = Props.className;
  var badgeDataTestId = Props.badgeDataTestId;
  var children = Props.children;
  var tabIndexOpt = Props.tabIndex;
  var onClick = onClickOpt !== undefined ? onClickOpt : function (e) {};
  var onMouseDown = onMouseDownOpt !== undefined ? onMouseDownOpt : function (e) {};
  var disabled = disabledOpt !== undefined ? disabledOpt : false;
  var shadow = shadowOpt !== undefined ? shadowOpt : false;
  var dark = darkOpt !== undefined ? darkOpt : false;
  var outline = outlineOpt !== undefined ? outlineOpt : false;
  var clear = clearOpt !== undefined ? clearOpt : false;
  var rounded = roundedOpt !== undefined ? roundedOpt : true;
  var scale = scaleOpt !== undefined ? scaleOpt : false;
  var relative = relativeOpt !== undefined ? relativeOpt : true;
  var iconSize = iconSizeOpt !== undefined ? iconSizeOpt : /* Normal */2;
  var labelSize = labelSizeOpt !== undefined ? labelSizeOpt : /* Normal */2;
  var iconFirst = iconFirstOpt !== undefined ? iconFirstOpt : true;
  var vertical = verticalOpt !== undefined ? verticalOpt : false;
  var noMargin = noMarginOpt !== undefined ? noMarginOpt : false;
  var iconClassName = iconClassNameOpt !== undefined ? iconClassNameOpt : "";
  var labelClassName = labelClassNameOpt !== undefined ? labelClassNameOpt : "";
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var tabIndex = tabIndexOpt !== undefined ? tabIndexOpt : 0;
  var match = React.useState(function () {
    return false;
  });
  var setIsBusy = match[1];
  var isBusy = match[0];
  var icon$1 = isBusy ? React.createElement(IconLoading$Showside.make, {}) : icon;
  var onClick$1 = disabled || isBusy ? undefined : function (e) {
    if (onClickAsync !== undefined) {
      Curry._1(setIsBusy, function (param) {
        return true;
      });
      Curry._1(onClick, e);
      Curry._1(onClickAsync, e).finally(function (param) {
        Curry._1(setIsBusy, function (param) {
          return false;
        });
      });
      return;
    } else {
      return Curry._1(onClick, e);
    }
  };
  var match$1 = Belt_Option.getWithDefault(size, iconSize);
  var buttonSizeClassName;
  switch (match$1) {
    case /* Largest */0:
      buttonSizeClassName = "w-20 h-20";
      break;
    case /* Large */1:
      buttonSizeClassName = "w-14 h-14";
      break;
    case /* Normal */2:
      buttonSizeClassName = "w-12 h-12";
      break;
    case /* Small */3:
      buttonSizeClassName = "w-10 h-10";
      break;
    case /* Smallest */4:
      buttonSizeClassName = "w-8 h-8";
      break;
  }
  var tmp;
  switch (iconSize) {
    case /* Largest */0:
      tmp = "w-8 h-8";
      break;
    case /* Normal */2:
      tmp = "";
      break;
    case /* Large */1:
    case /* Small */3:
      tmp = "w-7 h-7";
      break;
    case /* Smallest */4:
      tmp = "w-6 h-6";
      break;
  }
  var iconSizeClassName = CSS$Showside.prefix(tmp);
  var labelTextSize;
  switch (labelSize) {
    case /* Largest */0:
      labelTextSize = "text-3xl";
      break;
    case /* Large */1:
      labelTextSize = "text-2xl";
      break;
    case /* Normal */2:
      labelTextSize = "text-xl";
      break;
    case /* Small */3:
      labelTextSize = "text-lg";
      break;
    case /* Smallest */4:
      labelTextSize = "text-base";
      break;
  }
  var margin = iconFirst ? noMargin || vertical ? "" : "ml-2" : noMargin || vertical ? "" : "mr-2";
  var flexDir = vertical ? "flex-col" : "flex-row";
  var theme = dark ? clear ? "text-white" : "bg-black text-white" : clear ? "text-primary" : "bg-main text-primary";
  var finalLabel;
  if (label !== undefined) {
    var tmp$1 = {
      className: Cn.make([CSS$Showside.prefix(margin), CSS$Showside.prefix(labelTextSize), labelClassName, CSS$Showside.prefix("whitespace-nowrap")])
    };
    if (labelStyle !== undefined) {
      tmp$1.style = Caml_option.valFromOption(labelStyle);
    }
    finalLabel = React.createElement("span", tmp$1, label);
  } else {
    finalLabel = null;
  }
  var wrapperClassName = Cn.make([CSS$Showside.prefix(Cn.make(["p-0 inline-flex items-center justify-center", "dark-hover darker-active", "leading-none", "cursor-pointer", "no-touch-highlight", "select-none", flexDir, shadow ? "shadow-lg" : "", relative ? "relative" : "", theme, rounded ? "rounded-full" : "", scale ? "transition-transform duration-300 transform-gpu hover:scale-105" : ""])), className]);
  var renderOutline = function (param) {
    return React.createElement("div", {
      className: CSS$Showside.prefix("border-solid border border-primary opacity-25 absolute inset-0 rounded-inherit")
    });
  };
  var renderContent = function (param) {
    var tmp;
    if (Caml_obj.notequal(icon$1, null)) {
      var tmp$1 = {
        size: iconSize >= 4 ? /* Small */0 : /* Normal */1,
        className: CSS$Showside.prefix("top-px right-px")
      };
      if (badge !== undefined) {
        tmp$1.text = badge;
      }
      if (badgeDataTestId !== undefined) {
        tmp$1.dataTestId = Caml_option.valFromOption(badgeDataTestId);
      }
      tmp = React.createElement("div", {
        className: CSS$Showside.prefix(Cn.make(["relative inline-flex items-center justify-center", clear && dark ? "drop-shadow filter" : "", buttonSizeClassName]))
      }, React.createElement(Spread$Showside.make, {
        props: {
          className: Cn.make([iconSizeClassName, iconClassName])
        },
        children: icon$1
      }), React.createElement(Badge$Showside.make, tmp$1));
    } else {
      tmp = React.createElement("span", {
        className: CSS$Showside.prefix(Cn.make(["inline-block h-8", margin]))
      });
    }
    return React.createElement(React.Fragment, undefined, Belt_Option.getWithDefault(children, null), iconFirst ? null : finalLabel, tmp, iconFirst ? finalLabel : null, outline ? renderOutline(undefined) : null);
  };
  var tmp$2;
  var exit = 0;
  if (href !== undefined && href !== "") {
    var tmp$3 = {
      className: Cn.make([wrapperClassName, disabled ? CSS$Showside.prefix("pointer-events-none opacity-50") : "", CSS$Showside.prefix("font-button")]),
      href: href,
      onMouseDown: onMouseDown
    };
    if (title !== undefined) {
      tmp$3.title = Caml_option.valFromOption(title);
    }
    if (onClick$1 !== undefined) {
      tmp$3.onClick = Caml_option.valFromOption(onClick$1);
    }
    tmp$2 = React.createElement("a", tmp$3, renderContent(undefined));
  } else {
    exit = 1;
  }
  if (exit === 1) {
    var tmp$4 = {
      className: Cn.make([wrapperClassName, disabled ? CSS$Showside.prefix("pointer-events-none opacity-50") : "", CSS$Showside.prefix("font-button")]),
      tabIndex: tabIndex,
      onMouseDown: onMouseDown
    };
    var tmp$5 = tabIndex === -1 ? undefined : "button";
    if (tmp$5 !== undefined) {
      tmp$4.role = Caml_option.valFromOption(tmp$5);
    }
    if (title !== undefined) {
      tmp$4.title = Caml_option.valFromOption(title);
    }
    if (onClick$1 !== undefined) {
      tmp$4.onClick = Caml_option.valFromOption(onClick$1);
    }
    tmp$2 = React.createElement("div", tmp$4, renderContent(undefined));
  }
  var tmp$6 = {
    children: tmp$2
  };
  if (dataActive !== undefined) {
    tmp$6.dataActive = Caml_option.valFromOption(dataActive);
  }
  if (dataTestId !== undefined) {
    tmp$6.dataTestId = Caml_option.valFromOption(dataTestId);
  }
  return React.createElement(DataAttribute$Showside.make, tmp$6);
}
IconButton.displayName = "IconButton";
var make = IconButton;
export { make };
/* react Not a pure module */